import { createApi } from '@reduxjs/toolkit/query/react'
import { transformResponse, baseQuery } from '../../helpers/rtk-query-tools';
import Cookies from 'js-cookie';
import Config from '../../../app.config';

export interface LoginArgs {
  username: string
  password: string
}

export interface GetCustomerDataArgs {
  noCache?: boolean
}

export interface RateSongArgs {
  like: boolean
  songId: number
  stationId: number
  comment: string
}

export const apiAuth = createApi({
  reducerPath: 'apiAuth',
  baseQuery,
  endpoints: builder => ({
    login: builder.mutation<any, LoginArgs>({
      query: args => ({
        url: 'customer_service/authenticate',
        method: 'POST',
        body: {
          data: {
            Customer: {
              username: args.username,
              password: args.password
            }
          }
        }
      }),
      transformResponse
    }),
    getCustomerData: builder.query<any, GetCustomerDataArgs>({
      query: args => `customer_service/get_customer_data${args.noCache === true ? '/1' : ''}`,
      forceRefetch: () => true,
      transformResponse
    }),
    rateSong: builder.mutation<any, RateSongArgs>({
      query: args => ({
        url: `customer_service/${args.like ? 'like_song' : 'do_not_like_song'}/${args.songId}/${args.stationId}`,
        method: 'POST',
        body: {
          comment: args.comment
        }
      }),
      transformResponse
    })
  })
});

export const getTMSSession = (): string | undefined => {
  return Cookies.get('KMSSESSION');
};

export const hasTMSSession = (): boolean => {
  return Cookies.get('KMSSESSION') !== undefined;
};

export const removeTMSSession = (): void => {
  Cookies.remove('KMSSESSION', {
    domain: Config.cookieDomain,
    path: '/'
  });
};

export const isKnownUser = (): boolean => {
  const knownUser = Cookies.get('WEBUI_KNOWN_USER') === 'true';
  if (knownUser) {
    Cookies.set('WEBUI_KNOWN_USER', 'true', { expires: 400 });
  }
  return knownUser;
};

export const toggleKnownUser = (): void => {
  Cookies.set('WEBUI_KNOWN_USER', 'true', { expires: 400 });
};

export const {
  useLoginMutation,
  useGetCustomerDataQuery,
  useLazyGetCustomerDataQuery,
  useRateSongMutation
} = apiAuth;
